import { copyrightService } from '@/utils/request'

// 版权管理相关接口

// 获取版权管理接口
export function getCopyRightManagerList (data) {
  return copyrightService({
    url: 'copyrightWorksInfo/getCopyrightRegistration',
    method: 'post',
    data: data
  })
}
// 获取著作人管理列表
export function getAuthorManagerList (data) {
  return copyrightService({
    url: 'attestationPersonal/getAllAttestation',
    method: 'post',
    data: data
  })
}
// 添加个人认证
export function addPersonApply (data) {
  return copyrightService({
    url: 'attestationPersonal/addAttestationPersonal',
    method: 'post',
    data: data
  })
}
// 修改个人认证
export function updatePersonApply (data) {
  return copyrightService({
    url: 'attestationPersonal/updateAttestationPersonalList',
    method: 'post',
    data: data
  })
}

// 获取认证详情
export function getApplyDetail (params) {
  return copyrightService({
    url: 'attestationPersonal/getAttestationByIdAndType',
    method: 'get',
    params: params
  })
}

// 添加企业认证
export function addCompanyApply (data) {
  return copyrightService({
    url: 'attestationCompany/addAttestationCompany',
    method: 'post',
    data: data
  })
}

// 修改企业认证
export function updateCompanyApply (data) {
  return copyrightService({
    url: 'attestationCompany/updateAttestationCompany',
    method: 'post',
    data: data
  })
}

// 删除认证
export function deleteApply (params) {
  return copyrightService({
    url: 'attestationPersonal/delAttestationPersonalList',
    method: 'get',
    params: params
  })
}

// 获取版权统计
export function getCopyrightStatics (data) {
  return copyrightService({
    url: 'statistics/copyrightStatistics',
    method: 'post',
    data: data
  })
}
